import React from "react";
import GiftItem from "./GiftItem";

export default function GiftList({ gifts }) {
  return (
    <>
      {gifts.map(gift => (
        <GiftItem key={gift.id} gift={gift} />
      ))}
    </>
  );
}
